import { Controller } from "@hotwired/stimulus"
import { mountVueComponent, unmountVueComponent } from "../vue/mount"

/**
 * Vue Bridge Controller
 *
 * Mounts a registered Vue component inside this element. Stimulus manages
 * lifecycle (connect/disconnect) while Vue handles reactive UI state.
 *
 * Usage:
 * <div data-controller="vue-bridge"
 *      data-vue-bridge-component-value="SearchAutocomplete"
 *      data-vue-bridge-props-value='{"url":"/search","adminMode":false}'>
 * </div>
 *
 * Register new components in app/javascript/vue/registry.js.
 */
export default class extends Controller {
  static values = {
    component: String,
    props: { type: Object, default: {} },
  }

  connect() {
    this.app = mountVueComponent(this.element, this.componentValue, this.propsValue)
  }

  disconnect() {
    unmountVueComponent(this.app)
    this.app = null
  }
}
